import z from "zod";
import createSchemaUtils from "../../helpers/createSchemaUtils";
import { SafeNameSchema } from "../common";
import { PlainObjectSchema } from "../PlainObject";
import {
    QueryFilterDeclarativeSchema,
    QueryFilterGroupSchema,
    QueryFilterItemSchema
} from "./QueryFilters";

export * from "./QueryFilters";

//#region QuickSearchFilter
export const QuickSearchFilterSchema = z.object({
    type: z.enum(["and", "or"]).default("or"),
    filters: z.object({
        field: SafeNameSchema,
        operator: z.enum(["contains", "equals", "startsWith", "endsWith"]).default("contains").optional(),
    }).array().nonempty(),
});
export type QuickSearchFilter = z.infer<typeof QuickSearchFilterSchema>;
export const QuickSearchFilter = createSchemaUtils(QuickSearchFilterSchema);
//#endregion

//#region QueryEndpoint
export const QueryEndpointSchema = z.object({
    type: z.enum(["rest", "odata"]).default("odata").optional(),
    url: z.string().nonempty(),
    headers: z.record(z.string().nonempty(), z.string()).optional(),
    method: z.enum(["GET", "POST", "PUT", "DELETE"]).default("GET").optional(),
});
export type QueryEndpoint = z.infer<typeof QueryEndpointSchema>;
export const QueryEndpoint = createSchemaUtils(QueryEndpointSchema);
//#endregion

//#region SortOption
export const SortOptionSchema = z.object({
    field: SafeNameSchema,
    direction: z.enum(["asc", "desc"]).default("asc").optional(),
});
export type SortOption = z.infer<typeof SortOptionSchema>;
export const SortOption = createSchemaUtils(SortOptionSchema);
//#endregion

//#region QueryItemsResult
const QueryItemsResultSchema = z.object({
    count: z.number().min(0),
    items: PlainObjectSchema.array(),
});
export type QueryItemsResult = z.infer<typeof QueryItemsResultSchema>;
export const QueryItemsResult = createSchemaUtils(QueryItemsResultSchema);
export const EmptyQueryItemsResult: QueryItemsResult = Object.freeze({ count: 0, items: [] });
//#endregion

//#region QueryItemsArgs
export const QueryItemsArgsSchema = z.object({
    page: z.number().min(1).default(1),
    pageSize: z.number().min(1).max(1e6).default(50),
    search: z.string(),
    sort: SortOptionSchema.array(),
    filter: z.union([
        QueryFilterItemSchema,
        QueryFilterGroupSchema,
        QueryFilterDeclarativeSchema
    ]).optional(),
    context: PlainObjectSchema.optional(),
}).partial();
export type QueryItemsArgs = z.infer<typeof QueryItemsArgsSchema>;
export const QueryItemsArgs = createSchemaUtils(QueryItemsArgsSchema);
//#endregion


export const ODataQueryResultSchema = z.object({
    "@odata.count": z.number().min(0),
    value: PlainObjectSchema.array(),
});
export type ODataQueryResult = z.infer<typeof ODataQueryResultSchema>;
export const ODataQueryResult = createSchemaUtils(ODataQueryResultSchema);